export default "__VITE_ASSET__Bz67$Cyn__"